<template>

        <form>

            <div class="input-group" :class="{ error : containsError('old_password')}">
                <label for="old-password">Huidig wachtwoord</label>
                <input type="password" name="old_password" id="old_password" v-model="old_password" @keyup.enter.prevent="submit" />
            </div>

            <div class="input-group" :class="{ error : containsError('password')}">
                <label for="password">Nieuw wachtwoord <span class="example">— minimaal 8 tekens</span></label>
                <input type="password" name="password" id="password" v-model="new_password" @keyup.enter.prevent="submit" />
            </div>

            <div class="input-group" :class="{ error : containsError('passwordConfirmation')}">
                <label for="passwordConfirmation">Herhaal nieuw wachtwoord</label>
                <input type="password" name="passwordConfirmation" id="passwordConfirmation" v-model="new_passwordConfirmation" @keyup.enter.prevent="submit">
            </div>

            <primary-button @clicked="submit" :loading="loading" >Opslaan</primary-button>

        </form>

</template>


<script>
import api from 'js/api/resources';
import notify from 'js/components/notifications/notificationsMixin';
import validation from 'js/components/auth/validationMixin';

import PrimaryButton from 'js/components/elements/PrimaryButton.vue';

export default {
    name: 'SettingsPassword',
    mixins: [ notify, validation ],
    components: { PrimaryButton },
    props: {
        user: {},
    },
    data: function() {
        return {
            old_password: null,
            new_password: null,
            new_passwordConfirmation: null,
            loading: false,
            errors: [],
            errorFields: [],
        }
    },
    vuex: {
        getters: {
            isDemo: state => state.users.current.role === 'demo'
        }
    },
    methods: {
        submit: function(e) {

            e.preventDefault();

            if ( this.validate() ) {

                if ( this.isDemo ) {
                    this.$demoSuccessNotification()
                    this.reset()
                    return
                }

                this.loading = true

                api.editUserPassword(this.user.id, this.old_password, this.new_password, this.new_passwordConfirmation )
                    .then( () => this.$success('Je wachtwoord is aangepast.', { id: 'validation'  } ) )
                    .catch( response => {
                        if ( response.status === 403 ) {
                            this.addError('old_password', 'Je huidige wachtwoord klopt niet.')
                            this.showErrors()
                        } else {
                            this.handleErrorResponse(response, 'Aanpassen wachtwoord is mislukt.')
                        }
                    })
                    .then(this.reset)

            }

        },

        reset: function() {
            this.old_password = null
            this.new_password = null
            this.new_passwordConfirmation = null
            this.loading = false
        },

        validateFields: function() {
            this.validatePasswordLength(this.new_password)
            this.validatePasswordEqual(this.new_password, this.new_passwordConfirmation)
        },

    }

}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Password.vue?bfd443f0